import React from "react";
import { Link } from "react-router-dom";
import type { Location } from "../../../../interfaces/country.interface";

const FALLBACK_IMAGE = "/iceholidays-assets/images/destination-background.png";

function listingLink(location: Location) {
  return `/web/listing?keyword=${encodeURIComponent(location.name)}&location_id=${location.id}`;
}

function normalizeCoverUrl(url?: string) {
  if (!url) return FALLBACK_IMAGE;

  try {
    const parsedUrl = new URL(url, window.location.origin);

    if (parsedUrl.pathname.startsWith("/rails/active_storage/")) {
      return `${parsedUrl.pathname}${parsedUrl.search}`;
    }
  } catch (_error) {
    return url;
  }

  return url;
}

export default function DestinationCard({ destination }: { destination: Location }) {
  return (
    <Link to={listingLink(destination)} className="v2-tag-card">
      <div className="v2-tag-card__frame">
        <div className="v2-tag-card__photo">
          <span className="v2-tag-card__img" style={{ backgroundImage: `url(${normalizeCoverUrl(destination.cover)})` }} aria-hidden="true" />
          <span className="v2-tag-card__strap" aria-hidden="true" />
          <span className="v2-tag-card__label">{destination.name}</span>
        </div>
      </div>
    </Link>
  );
}
